import { getAuthUserInfo } from "../../infra/security/auth-user-token"


export interface UserSession {
  studentKey: string;
  centerKey: string;
  name: string;
  centerTimezone: string;
}

export function getUserSession (): UserSession {

  const authInfo = getAuthUserInfo();
  const timezone = localStorage.getItem("cent_timezone_identifier");

  return {
    studentKey: authInfo?.student_key,
    centerKey: authInfo?.pk_cent_key,
    name: authInfo?.name!,
    centerTimezone: timezone!
  }
}